import { render, staticRenderFns } from "./InventorySummaryPacking.vue?vue&type=template&id=9c4d8416&"
import script from "./InventorySummaryPacking.vue?vue&type=script&lang=js&"
export * from "./InventorySummaryPacking.vue?vue&type=script&lang=js&"
import style0 from "./InventorySummaryPacking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports